<template>

  <form action="">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">Abschlagsrechnung auswählen</p>
        <button
            type="button"
            class="delete"
            @click="$emit('close')"/>
      </header>
      <section class="modal-card-body">
        <b-table
            :current-page.sync="currentPage"
            :data="data"
            :default-sort-direction="defaultSortDirection"
            :paginated="isPaginated"
            :pagination-position="paginationPosition"
            :pagination-simple="isPaginationSimple"
            :per-page="20"
            :sort-icon="sortIcon"
            :sort-icon-size="sortIconSize"
            aria-current-label="Current page"
            aria-next-label="Next page"
            aria-page-label="Page"
            aria-previous-label="Previous page"
            default-sort="name"
            :selected.sync="value"
            focusable>

          <template>
            <b-table-column field="document_nr" label="R-Nr." numeric sortable width="40" v-slot="props">
              {{ props.row.document_nr }}
            </b-table-column>

            <b-table-column field="customer.name" label="Kunde" searchable sortable v-slot="props">
              {{ props.row.customer.name }}
            </b-table-column>

            <b-table-column field="project.name" label="Projekt" searchable sortable v-slot="props">
              {{ props.row.project ? props.row.project.name : "-" }}
            </b-table-column>

            <b-table-column field="total" label="Summe" searchable numeric sortable v-slot="props">
              {{ props.row.total }}
            </b-table-column>
          </template>
        </b-table>

      </section>
      <footer class="modal-card-foot">
        <b-button
            label="Close"
            @click="$emit('close')" />
        <b-button
            label="OK"
            type="is-primary"
            :disabled="value==null"
            @click="confirm" />
        <div>Aktuelle Auswahl: {{ value ? value.name : "Noch keine" }}</div>
      </footer>
    </div>
  </form>




</template>

<script>

// import apiservice from "@/services/apiservice";


import apiservice from "@/services/apiservice";

export default {
  name: 'InterimInvoicePickerPrompt',
  data() {
    return {
      data: [],
      isFetching: true
    }
  },
  props: {
    value: Object
  },
  methods: {
    fetchData: function() {
      this.isFetching = true;
      apiservice()
          .get("documents/open_interim_invoices")
          .then(response => (this.data = response.data.data));
      this.isFetching = false;
    },
    confirm() {
      // this.$emit('input', this.value)
      this.$emit('confirm', this.value)
      this.$emit('close')
    }
  },
  computed: {

  },
  beforeMount(){
    this.fetchData()
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>